import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      logout: "out",
    },
  },
  fr: {
    translation: {
      logout: "Se déconnecter",
      profil: "Profil",
      'authentified as': 'Connecté en tant que',
    },
  },
};

i18n
  .use(initReactI18next) 
  .init({
    resources,
    lng: "fr", 

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
